var _style, _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisaMastercard = function SvgVisaMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa-mastercard_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 203.7 58",
    style: {
      enableBackground: "new 0 0 203.7 58"
    },
    xmlSpace: "preserve",
    width: 237.5,
    height: 67.6
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".visa-mastercard_svg__st0{fill:#2a4d4f}")), /*#__PURE__*/React.createElement("g", {
    id: "visa-mastercard_svg__Group_421",
    transform: "translate(-523.75 -531.612)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa-mastercard_svg__Group_185",
    transform: "translate(523.75 549.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visa-mastercard_svg__Path_3092",
    className: "visa-mastercard_svg__st0",
    d: "M46.1 9.2c-.1 4 3.6 6.2 6.3 7.6 2.8 1.4 3.7 2.2 3.7 3.5 0 3.4-6.4 3.4-11.7 1l-1.3 6.1c6.9 3.2 20.5 1.8 20.5-8 0-7.3-10.2-7.7-10.1-11 .1-3.4 7-2.6 10.2-1.1l1.3-6c-9.7-3.6-18.9.7-18.9 7.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-mastercard_svg__Path_3093",
    className: "visa-mastercard_svg__st0",
    d: "M83.3.5h-6.1c-1.3 0-2.6.8-3.1 2L63.3 28.4h7.6l1.5-4.2h9.2l.9 4.2h6.7L83.3.5zm-8.9 18 3.8-10.4 2.2 10.4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-mastercard_svg__Path_3094",
    className: "visa-mastercard_svg__st0",
    d: "m36.9.5-6 27.8h7.2l6-27.8h-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-mastercard_svg__Path_3095",
    className: "visa-mastercard_svg__st0",
    d: "m26.3.5-7.5 18.9-3-16.1C15.5 1.7 14.1.5 12.5.5H.2l-.2.9c5.3 1.2 8.1 2 8.8 4.8l5.7 22.2h7.6L33.8.5h-7.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "visa-mastercard_svg__Group_420",
    transform: "translate(648.901 531.612)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "visa-mastercard_svg__Ellipse_105",
    cx: 51.9,
    cy: 26.7,
    style: {
      fill: "#487574"
    },
    r: 20.4
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "visa-mastercard_svg__Ellipse_106",
    className: "visa-mastercard_svg__st0",
    cx: 26.7,
    cy: 26.7,
    r: 20.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa-mastercard_svg__Path_3096",
    className: "visa-mastercard_svg__st0",
    d: "M18.1 57.7v-3.4c.1-1.1-.8-2.1-1.9-2.1h-.3c-.8-.1-1.5.3-1.9 1-.4-.6-1.1-1-1.8-1-.6 0-1.2.3-1.6.8v-.7h-1v5.4h1.2v-3c-.1-.7.4-1.3 1.1-1.4h.2c.8 0 1.2.5 1.2 1.4v3h1.2v-3c-.1-.7.4-1.3 1.1-1.4h.2c.8 0 1.2.5 1.2 1.4v3h1.1zm17.6-5.4h-1.9v-1.6h-1.2v1.6h-1.1v1.1h1.1v2.5c0 1.3.5 2 1.9 2 .5 0 1-.1 1.5-.4l-.3-1c-.3.2-.7.3-1 .3-.6 0-.8-.4-.8-.9v-2.5h1.9l-.1-1.1zm10-.1c-.6 0-1.1.3-1.4.8v-.7h-1.2v5.4h1.2v-3c0-.9.4-1.4 1.1-1.4.3 0 .5 0 .7.1l.4-1.1c-.3-.1-.5-.1-.8-.1zm-15.1.5c-.7-.4-1.4-.6-2.2-.6-1.4 0-2.3.7-2.3 1.7 0 .9.7 1.4 1.9 1.6l.6.1c.6.1.9.3.9.6 0 .4-.4.7-1.2.7-.6 0-1.3-.2-1.8-.6l-.6.9c.7.5 1.5.7 2.3.7 1.6 0 2.5-.7 2.5-1.8s-.7-1.4-1.9-1.6l-.6-.1c-.5-.1-.9-.2-.9-.5s.4-.6 1-.6 1.2.2 1.7.5l.6-1zm31.4-.5c-.6 0-1.1.3-1.4.8v-.7h-1.2v5.4h1.2v-3c0-.9.4-1.4 1.1-1.4.3 0 .5 0 .7.1l.4-1.1c-.2-.1-.5-.1-.8-.1zM46.9 55c-.1 1.5 1.1 2.8 2.6 2.8h.3c.7 0 1.4-.2 1.9-.6l-.6-.9c-.4.3-.9.5-1.4.5-1-.1-1.7-.9-1.6-1.9.1-.8.7-1.5 1.6-1.6.5 0 1 .2 1.4.5l.6-.9c-.5-.4-1.2-.7-1.9-.6-1.5-.1-2.8 1.1-2.9 2.6v.1zm11 0v-2.7h-1.2v.7c-.4-.5-1-.8-1.7-.8-1.6 0-2.8 1.3-2.8 2.9 0 1.5 1.3 2.7 2.8 2.8.7 0 1.3-.3 1.7-.8v.7h1.2V55zm-4.4 0c0-.9.8-1.6 1.7-1.6s1.6.8 1.6 1.7c0 .9-.8 1.6-1.7 1.6-.9 0-1.5-.7-1.6-1.6V55zm-14.2-2.8c-1.6 0-2.8 1.3-2.7 2.9 0 1.5 1.3 2.7 2.8 2.7.8 0 1.6-.2 2.2-.7l-.6-.9c-.4.4-1 .6-1.6.6-.8.1-1.5-.5-1.6-1.3h4V55c.1-1.4-.9-2.7-2.3-2.8h-.2zm0 1c.7 0 1.4.6 1.4 1.3h-2.8c0-.7.7-1.3 1.4-1.3zM68.8 55v-4.9h-1.1V53c-.4-.5-1-.8-1.7-.8-1.6 0-2.8 1.2-2.9 2.8 0 1.6 1.2 2.8 2.8 2.9h.1c.7 0 1.3-.3 1.7-.8v.7h1.1V55zm1.9 1.9h.2c.1 0 .1.1.2.1s.1.1.1.2c.1.1.1.3 0 .4 0 .1-.1.1-.1.2-.1 0-.1.1-.2.1h-.2c-.2 0-.4-.1-.5-.3-.1-.1-.1-.3 0-.4 0-.1.1-.1.1-.2.1 0 .1-.1.2-.1h.2zm0 1h.2l.1-.1c.1-.2.1-.4 0-.6l-.1-.1h-.4c-.1 0-.1.1-.1.1-.1.2-.1.4 0 .6l.1.1h.2zm.1-.7h.1c.1.1.1.2 0 .2 0 0-.1 0-.1.1l.2.2h-.1l-.2-.2h-.1v.2h-.1v-.5h.3zm-.2.1v.1h.2v-.2h-.1l-.1.1zM64.4 55c0-.9.8-1.6 1.7-1.6.9 0 1.6.8 1.6 1.7 0 .9-.8 1.6-1.7 1.6-.8 0-1.5-.7-1.6-1.6V55zm-39.6 0v-2.7h-1.2v.7c-.4-.5-1-.8-1.7-.8-1.6 0-2.8 1.2-2.9 2.8s1.2 2.8 2.8 2.9h.1c.7 0 1.3-.3 1.7-.8v.7h1.2V55zm-4.4 0c.1-.8.9-1.4 1.7-1.3s1.4.9 1.3 1.7c-.1.8-.9 1.4-1.7 1.3-.8-.1-1.3-.8-1.3-1.6V55z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M170.7 18.9c-1.4-3.4-3.6-6.1-6.2-8.2-7 5.5-9.8 15.2-6.2 23.8 1.4 3.4 3.6 6.1 6.2 8.2 7-5.5 9.8-15.2 6.2-23.8z",
    style: {
      fill: "#548e8e"
    }
  }));
};
export default SvgVisaMastercard;